import { render } from "./Show.vue?vue&type=template&id=0b1297bf&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=0b1297bf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0b1297bf"

export default script